var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.dialogTitle,
        width: "1400px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        closed: _vm.handleClosed,
      },
    },
    [
      _c("div", { staticClass: "statement-info-card" }, [
        _c("div", { staticClass: "info-row" }, [
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("商家类型：")]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(
                _vm._s(
                  _vm.merchantTypeText(_vm.statementInfo.merchantType) || "-"
                )
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("商家名称：")]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.statementInfo.merchantName || "-")),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("对账单号：")]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.statementInfo.statementNo || "-")),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("账单周期：")]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.statementInfo.periodDesc || "-")),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          staticClass: "detail-type-tabs",
          attrs: { type: "card" },
          on: { "tab-click": _vm.handleDetailTypeChange },
          model: {
            value: _vm.activeDetailTab,
            callback: function ($$v) {
              _vm.activeDetailTab = $$v
            },
            expression: "activeDetailTab",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "对账单", name: "statement" } }),
          _vm._v(" "),
          _c("el-tab-pane", {
            attrs: { label: "跨月订单", name: "crossMonth" },
          }),
          _vm._v(" "),
          _c("el-tab-pane", {
            attrs: { label: "已结算售后订单", name: "settledAfterSale" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter-section" },
        [
          _c(
            "el-form",
            {
              staticClass: "filter-form",
              attrs: { inline: "", size: "small", model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "交易单号：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "150px" },
                    attrs: { placeholder: "请输入", clearable: "" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleSearch($event)
                      },
                    },
                    model: {
                      value: _vm.searchForm.transactionId,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "transactionId", $$v)
                      },
                      expression: "searchForm.transactionId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "订单号：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "150px" },
                    attrs: { placeholder: "请输入", clearable: "" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleSearch($event)
                      },
                    },
                    model: {
                      value: _vm.searchForm.orderNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "orderNo", $$v)
                      },
                      expression: "searchForm.orderNo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.searchForm.detailType === ""
                ? _c(
                    "el-form-item",
                    { attrs: { label: "下单时间：" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "350px" },
                        attrs: {
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          type: "datetimerange",
                          "popper-class": "hide-clear-btn",
                          "range-separator": "-",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "default-time": ["00:00:00", "23:59:59"],
                          editable: false,
                          clearable: false,
                          "unlink-panels": true,
                        },
                        on: { change: _vm.handleChange },
                        model: {
                          value: _vm.searchForm.createTimeRange,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "createTimeRange", $$v)
                          },
                          expression: "searchForm.createTimeRange",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "订单状态：" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "120px" },
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.searchForm.orderStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "orderStatus", $$v)
                        },
                        expression: "searchForm.orderStatus",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "已取消", value: "0" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "待支付", value: "1" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "已支付", value: "2" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "处理中", value: "3" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "部分发货", value: "16" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "已发货", value: "4" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "已签收", value: "5" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "待退款", value: "71" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "退款中", value: "7" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "退款成功", value: "8" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "退款失败", value: "9" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "拒绝退款", value: "10" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "已关闭", value: "11" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "支付失败", value: "12" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "已完结", value: "6" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "向第三方下单失败", value: "13" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "部分退款", value: "14" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "售后中", value: "15" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "销售渠道：" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "120px" },
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.searchForm.customerId,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "customerId", $$v)
                        },
                        expression: "searchForm.customerId",
                      },
                    },
                    _vm._l(_vm.customerOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  class: { "filter-actions": _vm.searchForm.detailType === "" },
                  attrs: { label: "是否加入账单：" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "120px" },
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.searchForm.addedToStatement,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "addedToStatement", $$v)
                        },
                        expression: "searchForm.addedToStatement",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "已加入", value: true },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "未加入", value: false },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  class: { "filter-actions": _vm.searchForm.detailType === "" },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("搜索")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-refresh" },
                      on: { click: _vm.handleReset },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isChecked && _vm.searchForm.detailType === ""
            ? _c(
                "div",
                { staticClass: "batch-actions" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["admin:merchant:statement:order:addByFilter"],
                          expression:
                            "['admin:merchant:statement:order:addByFilter']",
                        },
                      ],
                      attrs: {
                        size: "small",
                        type: "primary",
                        loading: _vm.batchAddLoading,
                      },
                      on: { click: _vm.handleBatchAdd },
                    },
                    [_vm._v("将筛选结果全部添加至对账单")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: [
                            "admin:merchant:statement:order:removeByFilter",
                          ],
                          expression:
                            "['admin:merchant:statement:order:removeByFilter']",
                        },
                      ],
                      attrs: {
                        size: "small",
                        type: "warning",
                        loading: _vm.batchRemoveLoading,
                      },
                      on: { click: _vm.handleBatchRemove },
                    },
                    [_vm._v("将筛选结果从对账单中移除")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          ref: "orderTable",
          staticClass: "order-table",
          attrs: {
            data: _vm.listData.list,
            size: "small",
            stripe: "",
            border: "",
            "header-cell-style": {
              background: "#f5f7fa",
              color: "#606266",
              fontWeight: "bold",
            },
            "row-class-name": _vm.tableRowClassName,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "platformOrderNo",
              label: "交易单号",
              "min-width": "190",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "orderNo",
              label: "平台订单号",
              "min-width": "190",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "salesAttribute",
              label: "销售属性",
              "min-width": "100",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "orderAmount",
              label: "订单金额",
              "min-width": "110",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "amount-cell" }, [
                      _c("span", [
                        _vm._v(
                          "￥" + _vm._s(_vm.formatAmount(scope.row.orderAmount))
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.hasAmount(scope.row.freight)
                        ? _c("div", { staticClass: "amount-extra" }, [
                            _vm._v(
                              "含运费：￥" +
                                _vm._s(_vm.formatAmount(scope.row.freight))
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasAmount(scope.row.packingFee)
                        ? _c("div", { staticClass: "amount-extra" }, [
                            _vm._v(
                              "打包费：￥" +
                                _vm._s(_vm.formatAmount(scope.row.packingFee))
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "settlementAmount",
              label: "成交结算金额",
              "min-width": "130",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "amount-cell" }, [
                      _c("span", [
                        _vm._v(
                          "￥" +
                            _vm._s(_vm.formatAmount(scope.row.settlementAmount))
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.hasAmount(scope.row.freight)
                        ? _c("div", { staticClass: "amount-extra" }, [
                            _vm._v(
                              "含运费：￥" +
                                _vm._s(_vm.formatAmount(scope.row.freight))
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasAmount(scope.row.packingFee)
                        ? _c("div", { staticClass: "amount-extra" }, [
                            _vm._v(
                              "打包费：￥" +
                                _vm._s(_vm.formatAmount(scope.row.packingFee))
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "actualSettlementAmount",
              label: "实际结算金额",
              "min-width": "130",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "amount-cell" }, [
                      _c("span", { staticClass: "actual-amount" }, [
                        _vm._v(
                          "￥" +
                            _vm._s(_vm.formatActualSettlementAmount(scope.row))
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.hasAmount(scope.row.actualSettlementFreight)
                        ? _c("div", { staticClass: "amount-extra" }, [
                            _vm._v(
                              "含运费：￥" +
                                _vm._s(
                                  _vm.formatAmount(
                                    scope.row.actualSettlementFreight
                                  )
                                )
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasAmount(scope.row.actualSettlementPackingFee)
                        ? _c("div", { staticClass: "amount-extra" }, [
                            _vm._v(
                              "打包费：￥" +
                                _vm._s(
                                  _vm.formatAmount(
                                    scope.row.actualSettlementPackingFee
                                  )
                                )
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _vm.searchForm.detailType === 2
            ? _c("el-table-column", {
                attrs: {
                  prop: "settledAfterSaleDifference",
                  label: "已结算售后价差",
                  "min-width": "130",
                  align: "center",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "amount-cell" }, [
                            _c("span", { staticClass: "actual-amount" }, [
                              _vm._v(
                                "￥" +
                                  _vm._s(
                                    _vm.formatAmount(
                                      scope.row.settledAfterSaleDifference
                                    )
                                  )
                              ),
                            ]),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2977576657
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "lossAmount",
              label: "损失金额",
              "min-width": "110",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      { class: scope.row.lossAmount > 0 ? "loss-amount" : "" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              scope.row.lossAmount > 0
                                ? "￥" + _vm.formatAmount(scope.row.lossAmount)
                                : "-"
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "orderStatus",
              label: "订单状态",
              "min-width": "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.orderStatusType(scope.row.orderStatus),
                          size: "small",
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.orderStatusText(scope.row.orderStatus)) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "addedToStatement",
              label: "是否加入账单",
              "min-width": "110",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: scope.row.addedToStatement ? "success" : "info",
                          size: "small",
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              scope.row.addedToStatement ? "已加入" : "未加入"
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "customerId",
              label: "销售渠道",
              "min-width": "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(_vm._s(_vm.getCustomerName(scope.row.customerId))),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "createTime",
              label: "下单时间",
              "min-width": "160",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(_vm._s(_vm.formatCreateTime(scope.row.createTime))),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "reconciliationRemark",
              label: "对账备注",
              "min-width": "160",
              "show-overflow-tooltip": "",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "financialRemark",
              label: "财务备注",
              "min-width": "160",
              "show-overflow-tooltip": "",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              "min-width": "220",
              align: "center",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.addedToStatement
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: [
                                  "admin:merchant:statement:order:update",
                                ],
                                expression:
                                  "['admin:merchant:statement:order:update']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEditOrder(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑订单")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isChecked && scope.row.addedToStatement
                      ? [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "has-permi",
                                  rawName: "v-has-permi",
                                  value: [
                                    "admin:merchant:statement:order:remark",
                                  ],
                                  expression:
                                    "['admin:merchant:statement:order:remark']",
                                },
                              ],
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleFinancialRemark(scope.row)
                                },
                              },
                            },
                            [_vm._v("财务备注")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "has-permi",
                                  rawName: "v-has-permi",
                                  value: [
                                    "admin:merchant:statement:order:remark",
                                  ],
                                  expression:
                                    "['admin:merchant:statement:order:remark']",
                                },
                              ],
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleReconciliationRemark(
                                    scope.row
                                  )
                                },
                              },
                            },
                            [_vm._v("对账备注")]
                          ),
                        ]
                      : !_vm.isChecked && scope.row.addedToStatement
                      ? [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "has-permi",
                                  rawName: "v-has-permi",
                                  value: [
                                    "admin:merchant:statement:order:remark",
                                  ],
                                  expression:
                                    "['admin:merchant:statement:order:remark']",
                                },
                              ],
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleFinancialRemark(scope.row)
                                },
                              },
                            },
                            [_vm._v("财务备注")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "has-permi",
                                  rawName: "v-has-permi",
                                  value: [
                                    "admin:merchant:statement:order:remark",
                                  ],
                                  expression:
                                    "['admin:merchant:statement:order:remark']",
                                },
                              ],
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleReconciliationRemark(
                                    scope.row
                                  )
                                },
                              },
                            },
                            [_vm._v("对账备注")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "has-permi",
                                  rawName: "v-has-permi",
                                  value: [
                                    "admin:merchant:statement:order:item:update",
                                  ],
                                  expression:
                                    "['admin:merchant:statement:order:item:update']",
                                },
                              ],
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleEditDetail(scope.row)
                                },
                              },
                            },
                            [_vm._v("编辑明细")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "has-permi",
                                  rawName: "v-has-permi",
                                  value: [
                                    "admin:merchant:statement:order:remove",
                                  ],
                                  expression:
                                    "['admin:merchant:statement:order:remove']",
                                },
                              ],
                              staticClass: "remove-btn",
                              attrs: {
                                type: "text",
                                size: "small",
                                loading: scope.row._loading,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleRemoveOne(scope.row)
                                },
                              },
                            },
                            [_vm._v("从对账单移除")]
                          ),
                        ]
                      : _vm.isChecked && !scope.row.addedToStatement
                      ? [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "text",
                                size: "small",
                                disabled: "",
                              },
                            },
                            [_vm._v("已核对")]
                          ),
                        ]
                      : !_vm.isChecked && !scope.row.addedToStatement
                      ? [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "has-permi",
                                  rawName: "v-has-permi",
                                  value: ["admin:merchant:statement:order:add"],
                                  expression:
                                    "['admin:merchant:statement:order:add']",
                                },
                              ],
                              staticClass: "add-btn",
                              attrs: {
                                type: "text",
                                size: "small",
                                loading: scope.row._loading,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleAddOne(scope.row)
                                },
                              },
                            },
                            [_vm._v("添加至对账单")]
                          ),
                        ]
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.listData.total > 0
        ? _c("el-pagination", {
            staticClass: "pagination",
            attrs: {
              "current-page": _vm.pagination.page,
              "page-sizes": [10, 20, 30, 50],
              "page-size": _vm.pagination.limit,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.listLoading && _vm.listData.list.length === 0
        ? _c("div", { staticClass: "empty-state" }, [
            _c("i", { staticClass: "el-icon-folder-opened empty-icon" }),
            _vm._v(" "),
            _c("p", { staticClass: "empty-text" }, [_vm._v("暂无订单数据")]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.reconciliationRemarkDialogVisible,
            title: "对账备注",
            width: "500px",
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.reconciliationRemarkDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.remarkForm,
                "label-width": "90px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "对账备注：" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      placeholder: "请输入对账备注",
                    },
                    model: {
                      value: _vm.remarkForm.reconciliationRemark,
                      callback: function ($$v) {
                        _vm.$set(_vm.remarkForm, "reconciliationRemark", $$v)
                      },
                      expression: "remarkForm.reconciliationRemark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.reconciliationRemarkDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.remarkLoading,
                  },
                  on: { click: _vm.handleSaveReconciliationRemark },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.financialRemarkDialogVisible,
            title: "财务备注",
            width: "500px",
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.financialRemarkDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.remarkForm,
                "label-width": "90px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "财务备注：" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      placeholder: "请输入财务备注",
                    },
                    model: {
                      value: _vm.remarkForm.financialRemark,
                      callback: function ($$v) {
                        _vm.$set(_vm.remarkForm, "financialRemark", $$v)
                      },
                      expression: "remarkForm.financialRemark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.financialRemarkDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.remarkLoading,
                  },
                  on: { click: _vm.handleSaveFinancialRemark },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("EditStatementDetailDialog", {
        ref: "editStatementDetailDialog",
        on: { refresh: _vm.handleEditDetailRefresh },
      }),
      _vm._v(" "),
      _c("EditStatementOrderDialog", {
        ref: "editStatementOrderDialog",
        on: { refresh: _vm.handleEditOrderRefresh },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.remarkPopover.visible,
            title: _vm.remarkPopover.title,
            width: "500px",
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.remarkPopover, "visible", $event)
            },
          },
        },
        [
          _c("div", { staticClass: "remark-popover-content" }, [
            _vm._v(_vm._s(_vm.remarkPopover.content)),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }